/* eslint no-underscore-dangle: ["error", { "allow": ["__APIROOT"] }] */
import axios from "axios";

const host = document.location.host;
  
const baseUrl = (() => {
  switch (host) {
    case 'gildi.demo01.lisa.is':
      return 'https://gildi-auth.demo01.lisa.is';
    case 'localhost:5173':
      return 'https://localhost:58809';
    case 'sjodfelagavefur.gildi.is':
      return 'https://auth-api.gildi.is';
    default:
      console.warn(`Unrecognized host: ${host}`);
      return '';
  }
})();
export default function useAuthApi() {
  const axiosConfig = {
    withCredentials: true
  };

  function post(url: string, params?: Record<string, string | number>) {
    const config = {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      ...axiosConfig
    };
    const stringParams = Object.fromEntries(
      Object.entries(params ?? {}).map(([key, value]) => [key, String(value)])
    );
    const body = new URLSearchParams(stringParams).toString();
    return axios.post(`${baseUrl}/${url}`, body, config);
  }

  function postJson(url: string, params: unknown) {
    const config = {
      headers: { "Content-Type": "application/json" },
      ...axiosConfig
    };
    return axios.post(`${baseUrl}/${url}`, JSON.stringify(params), config);
  }

  function get(url: string) {
    return axios.get(`${baseUrl}/${url}`, axiosConfig);
  }

  return { post, postJson, get };
}
